import { generateScenarioFileUrl } from '@/utils/generateScenarioFileUrl';
import classNames from 'classnames';
import { Typewriter } from '../Typewriter';
import arrow from './-assets/arrow.svg';
import styles from './index.module.scss';

export type DialogProps = {
  dialog: string;
  name: string;
  character?: string | null;
  embaUserlastName: string;
  isEnableNext: boolean;
  slideToNext: () => void;
  animationComplete: () => void;
  typingSpeed: number;
  showBlinkingArrow: boolean;
};

export const Dialog: React.FC<DialogProps> = ({
  dialog,
  name,
  character,
  embaUserlastName,
  isEnableNext,
  slideToNext,
  animationComplete,
  typingSpeed,
  showBlinkingArrow,
}) => {
  const isMyDialog = name === '%username%';
  const isCharacter = name !== '解説';

  return (
    <div className={styles.bottomArea}>
      <div
        className={classNames(styles.dialogArea, {
          [styles.characterDialog]: isCharacter,
          [styles.myDialog]: isMyDialog,
        })}
      >
        {character && (
          <div className={styles.wipeWrapper}>
            <div className={styles.wipe}>
              <img
                className={styles.characterImage}
                src={generateScenarioFileUrl(character, 'character')}
                alt=""
              />
            </div>
          </div>
        )}

        <p
          className={classNames(styles.dialogName, {
            [styles.characterDialog]: isCharacter,
            [styles.myDialog]: isMyDialog,
          })}
        >
          {name.replace('%username%', embaUserlastName)}
        </p>

        <div
          className={classNames(styles.dialog, {
            [styles.hasNext]: isEnableNext,
          })}
          onClick={isEnableNext ? () => slideToNext() : undefined}
          role="button"
          tabIndex={0}
        >
          <p className={styles.dialogContent}>
            <Typewriter
              text={dialog.replace(/%username%/g, embaUserlastName)}
              onComplete={animationComplete}
              typingSpeed={typingSpeed}
            />
          </p>

          {showBlinkingArrow && (
            <img className={styles.blinkingArrow} src={arrow} alt="" />
          )}
        </div>
      </div>
    </div>
  );
};
